/* eslint-disable indent */
/* eslint-disable quotes */
import { useState, useEffect } from 'react';

import { useStore } from '../../../core/utils/hook';
import '../style.scss';
import { extractFileNameAndExt, formatBytes } from '../../../core/utils/common';
import moment from 'moment';
import { DATE_TIME_YMD, MSG } from '../../../core/configs/constants';
import { ReactNotifications } from '../../../components';

const handleValidateFile = (file, accept) => {
    const acceptList = accept
        .split(',')
        .map((type) => type.trim().toLowerCase());

    const fileExt = '.' + file.name.split('.').pop().toLowerCase();

    return acceptList.includes(fileExt);
};

const ModalEditVideo = (props) => {
    // store
    const {id} = props
    const {
        modalStore: { hide, show },
        shareKnowledgeStore: { getPresignedUrls, updateFile, getFileInfo },
        fileStore: { uploadFile }
    } = useStore();

    const [thumbnail, setThumbnail] = useState(null);
    const [fileInfo, setFileInfo] = useState(null);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        async function fetchFileInfo() {
            const res = await getFileInfo(id);
            if (res) {
                setFileInfo(res);
            }
        }
        fetchFileInfo();
    }, [id]);

    const handleUploadFile = async (fileUploadList, uploadSuccessCallback) => {
        const uploadPromises = fileUploadList.map((fileUpload) => {
            const fields = fileUpload?.fields;
            const { bucket, ...payload } = fields;
            const data = {
                ...(payload || {}),
                file: fileUpload.file
            };

            return new Promise((resolve, reject) => {
                uploadFile(fileUpload.presignedUrl, data, {
                    onSuccess: () => {
                        resolve(true);
                    },
                    onError: () => {
                        reject(false);
                    },
                    onUploadProgress: (progress) => {}
                });
            });
        });

        try {
            const results = await Promise.all(uploadPromises);

            const allSuccessful = results.every((result) => result === true);

            if (allSuccessful) {
                uploadSuccessCallback();
            }
        } catch (error) {
            console.error('Error during file upload:', error);
        }
    };

    const handleChangeThumbnail = (file) => {
        if (!file) {
            setThumbnail(null);
            setIsError(false);
            return;
        }
        const maxSize = 10 * 1024 * 1024;
        const isErr = file.size > maxSize;
        setIsError(isErr);
        setThumbnail(file);
    };

    const onSubmit = async (data) => {
        if (thumbnail) {
            const [thumbnailPresigned] = await getPresignedUrls({
                groupId: +fileInfo?.groupId,
                files: [
                    {
                        name: thumbnail?.name,
                        type: thumbnail?.type
                    }
                ],
                type: 3
            });
            await handleUploadFile(
                [
                    {
                        file: thumbnail,
                        presignedUrl: thumbnailPresigned.url,
                        fields: thumbnailPresigned.fields
                    }
                ],
                async () => {
                    const res = await updateFile({
                        id: fileInfo?.id,
                        thumbnail: thumbnailPresigned.fields.key
                    });
                    if (res) {
                        handleUploadSuccess();
                    }
                }
            );
        } else {
            const res = await updateFile({
                id: fileInfo?.id,
                thumbnail: fileInfo?.thumbnail
            });
            if (res) {
                handleUploadSuccess();
            }
        }
    };

    const handleUploadSuccess = () => {
        hide();
        ReactNotifications('success', MSG['inform.success.update'])
        props.onUploadSuccess();
    };

    return (
        <div className="modal-edit-file">
            <div className="content">
                <div className="file-info">
                    <div>
                        <p className='flex-none'>ファイル名</p>
                        <p className=''>
                            <span className="file-name line-clamp-1">
                                {
                                    extractFileNameAndExt(fileInfo?.name || '')
                                        .name
                                }
                            </span>
                            .{
                                extractFileNameAndExt(fileInfo?.name || '')
                                    .extension
                            }
                        </p>
                    </div>
                    <div>
                        <p>ファイルサイズ</p>
                        <p>{formatBytes(+fileInfo?.size)}</p>
                    </div>
                    <div>
                        <p>アップロード日</p>
                        <p>
                            {fileInfo?.createdAt
                                ? moment(fileInfo?.createdAt).format(
                                      DATE_TIME_YMD
                                  )
                                : ''}
                        </p>
                    </div>
                    <div>
                    <p>
                        サムネイル画像
                    </p>
                    <p>
                        <button
                            type="button"
                            onClick={() =>
                                document
                                    .getElementById('thumbnailInput')
                                    .click()
                            }
                            className="btn btn-select-thumb"
                        >
                            ファイルを選択
                        </button>
                        <input
                            id="thumbnailInput"
                            type="file"
                            accept="image/png, image/jpeg"
                            style={{ display: 'none' }}
                            onClick={(e) => {
                                e.currentTarget.value = '';
                            }}
                            onChange={(e) => {
                                const file = e.target.files?.[0];
                                const isValid = handleValidateFile(
                                    file,
                                    '.png,.jpg'
                                );
                                if (!isValid) return;
                                handleChangeThumbnail(file);
                            }}
                        />
                    </p>
                </div>
                </div>

                <div className="file-item">
                    {isError && (
                        <span className="text-red-primary text-12">
                            ファイルのアップロードに失敗しました。ファイルサイズが上限の10MBを超えています。再度お試しください。
                        </span>
                    )}
                    <div className="flex justify-content-center align-items-center">
                        {(thumbnail || fileInfo?.thumbnailUrl) && (
                            <div className="img-box">
                                <img
                                    src={
                                        thumbnail
                                            ? URL.createObjectURL(thumbnail)
                                            : fileInfo?.thumbnailUrl
                                    }
                                    alt="Thumbnail preview"
                                    className="thumbnail-preview"
                                    style={{
                                        height: '200px',
                                        maxWidth: '400px',
                                        objectFit: 'cover',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc'
                                    }}
                                />

                                <i
                                    class="fas fa-times icon-x"
                                    onClick={() => {
                                        setThumbnail(null);
                                        setFileInfo({
                                            ...fileInfo,
                                            thumbnail: null,
                                            thumbnailUrl: null
                                        });
                                        setIsError(false);
                                    }}
                                ></i>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="cancel" onClick={hide}>
                    キャンセル
                </button>
                <button
                    className="btn btn-submit"
                    onClick={onSubmit}
                    disabled={isError}
                >
                    保存
                </button>
            </div>
        </div>
    );
};

export default ModalEditVideo;
